import { CreateThreadType, ThreadsType, UpdateThreadType } from "types/ThreadsType";
import { FetchError } from "util/exceptions";
import { API_URL } from "./common";

export const getThreads = (token: string): Promise<ThreadsType[]> => {
    return fetch(`${API_URL}/v1/ecommerce/threads`, {
        method: 'GET',
        headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json',
        },
    }).then(response => {
        if (!response.ok) {
            throw new FetchError('Failed to fetch threads', response.status);
        }
        return response.json();
    });
};

export const createThread = (token: string, body: CreateThreadType): Promise<ThreadsType> => {
    return fetch(`${API_URL}/v1/ecommerce/threads`, {
        method: 'POST',
        headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(body),
    }).then(response => {
        if (!response.ok) {
            throw new FetchError('Failed to create thread', response.status);
        }
        return response.json();
    });
};

export const updateThread = (token: string, threadId: number, threadData: UpdateThreadType): Promise<ThreadsType> => {
    return fetch(`${API_URL}/v1/ecommerce/threads/${threadId}`, {
        method: 'PUT',
        headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(threadData),
    }).then(response => {
        if (!response.ok) {
            throw new FetchError('Failed to update thread', response.status);
        }
        return response.json();
    });
};

export const disableThread = (token: string, threadId: number): Promise<void> => {
    return fetch(`${API_URL}/v1/ecommerce/threads/${threadId}`, {
        method: 'DELETE',
        headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json',
        },
    }).then(response => {
        if (!response.ok) {
            throw new FetchError('Failed to disable thread', response.status);
        }
        return response.json();
    });
};